import { Menu } from '../models/menu.model';

export enum MenuItemsEnum {
	ResetPassword = 10,
}

export const menuItems = [
	new Menu(
		MenuItemsEnum.ResetPassword,
		`Reset Password`,
		'/new-ptm',
		null,
		'lock_reset',
		null,
		null,
		false,
		0
	)
];
